import { Component, input, output } from '@angular/core';

import type {
  AggregatedEvaluationsReviewerEvaluation,
  AggregatedEvaluationsStage,
} from '@core/evaluations-types';
import { Theme } from '@core/theme-util';

import { CandidateOfferEvaluationReviewerResultComponent } from '../candidate-offer-evaluation-reviewer-result/candidate-offer-evaluation-reviewer-result.component';

@Component({
  selector: 'rt-candidate-offer-evaluation-stage',
  templateUrl: './candidate-offer-evaluation-stage.component.html',
  styleUrl: './candidate-offer-evaluation-stage.component.less',
  imports: [CandidateOfferEvaluationReviewerResultComponent],
})
export class CandidateOfferEvaluationStageComponent {
  public stage = input.required<AggregatedEvaluationsStage>();

  public theme = input<Theme | null>(null);

  public useProsemirror = input(false);

  public edit = output<AggregatedEvaluationsReviewerEvaluation>();

  public delete = output<AggregatedEvaluationsReviewerEvaluation>();
}
